import { render } from "./OfficeTable.vue?vue&type=template&id=17ffcab3&scoped=true"
import script from "./OfficeTable.vue?vue&type=script&lang=js"
export * from "./OfficeTable.vue?vue&type=script&lang=js"

import "./OfficeTable.vue?vue&type=style&index=0&id=17ffcab3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ffcab3"]])

export default __exports__